export default __webpack_public_path__ + "static/media/AddIcon.970aaeac.svg";